import { TrialProduct, TrialProductIds } from "@onnit-js/ui/components/trials/disclaimers/trials";

export interface Trial {
    btnTitle: string;
    btnImageParams: string;
    title: string;
    description: string;
    img: string;
    imgAltText: string;
    quote: string;
    author: string;
    productSlug: string;
    productId: number;
    trialSlug: string;
    trialProductId: number;
}

type Trials = {
    [key in TrialProduct]: Trial;
};

export const trials: Trials = {
    [TrialProduct.TotalGutHealth]: {
        btnTitle: 'Total GUT HEALTH<span class="oui-sup" aria-hidden="true">®</span>',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title: 'Total GUT HEALTH<span class="oui-sup" aria-hidden="true">®</span>',
        description:
            'Total GUT HEALTH<span class="oui-sup" aria-hidden="true">®</span> offers digestive enzymes, probiotics, prebiotics, and other nutrients that help support a healthy digestive system and gut microbiome, as well as help you process the occasional heavy meal.<span class="oui-sup">†</span>︎',
        img: "2024-TGH-Free-Trial-Update-WPage-Quote.png",
        imgAltText: 'Joe Rogan speaking about Total GUT HEALTH<span class="oui-sup" aria-hidden="true">®</span>.',
        quote:
            'Total GUT HEALTH<span class="oui-sup" aria-hidden="true">®</span> helps you process the occasional heavy meal, digesting protein, fats & carbohydrates in addition to maintaining healthy immune system function.<span class="oui-sup">†</span>',
        author: "Joe Rogan, Co-Founder",
        productSlug: "total-gut-health",
        productId: 9321,
        trialSlug: "total-gut-health-trial",
        trialProductId: TrialProductIds.TotalGutHealth,
    },
    [TrialProduct.AlphaBrain]: {
        btnTitle: 'Alpha BRAIN<span class="oui-sup" aria-hidden="true">®</span>',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title: 'Alpha BRAIN<span class="oui-sup" aria-hidden="true">®</span>',
        description:
            'Alpha BRAIN<span class="oui-sup">®</span> is Onnit\'s flagship supplement—a nootropic that helps support cognitive functions, including memory, mental speed, and focus.<span class="oui-sup" aria-hidden="true">†</span> Since launching in 2010, more than ten million bottles have been sold.',
        img: "Rogan-Trial-Page-Quote.jpg",
        imgAltText: 'Joe Rogan speaking about Alpha BRAIN<span class="oui-sup" aria-hidden="true">®</span>.',
        quote:
            'Most of the things that I do require me to have a good memory, to be sharp, to be thinking about things clearly.  Alpha BRAIN<span class="oui-sup" aria-hidden="true">®</span> is the very best thing I\'ve ever found that helps me with that and I think most people could benefit from it.',
        author: "Joe Rogan, Co-Founder",
        productSlug: "alpha-brain",
        productId: 32,
        trialSlug: "alpha-brain-trial",
        trialProductId: TrialProductIds.AlphaBrain,
    },
    [TrialProduct.TotalHuman]: {
        btnTitle: 'Total Human<span class="oui-sup" aria-hidden="true">®</span>',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title: 'Total Human<span class="oui-sup" aria-hidden="true">®</span>',
        description:
            'Total Human<span class="oui-sup" aria-hidden="true">®</span> is a complete re-imagining of the daily multivitamin, offering components of several of Onnit’s best-in-class formulas in an all-in-one product that’s specifically balanced to help support the brain and bones, as well as mood state, cellular energy, and immune system health.<span class="oui-sup">†</span>',
        img: "2023-Free-Trial-Update-WPage-TH.png",
        imgAltText: "Man playing rugby.",
        quote:
            "Great, convenient packets! I used to have several bottles of supplements on my counter. I would have to guess what I needed, and how much/many to take. These packets take out the guess work. The night support is my favorite.",
        author: "Jeff F.",
        productSlug: "total-human",
        productId: 8282,
        trialSlug: "total-human-trial",
        trialProductId: TrialProductIds.TotalHuman,
    },
    [TrialProduct.NewMood]: {
        btnTitle: 'New MOOD<span class="oui-sup" aria-hidden="true">®</span>',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title: 'New MOOD<span class="oui-sup" aria-hidden="true">®</span>',
        description:
            'Great for unwinding after a long day at work, or helping to support a normal daily stress response. New MOOD<span class="oui-sup" aria-hidden="true">®</span> is like a deep breath and a smile.<span class="oui-sup">†</span>',
        img: "2024-NM-FreeTrial-Page-1920x1080.jpg",
        imgAltText: "Neen Williams working out.",
        quote: "Does what it says it does, love this product, on my 2nd bottle now. Glad I gave it a try.",
        author: "Sean Wigman",
        productSlug: "new-mood",
        productId: 46,
        trialSlug: "offer/aff/new-mood/",
        trialProductId: TrialProductIds.NewMood,
    },
    [TrialProduct.ShroomTechSport]: {
        btnTitle: 'Shroom Tech<span class="oui-sup" aria-hidden="true">®</span> SPORT',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title:
            'Shroom Tech<span class="oui-sup" aria-hidden="true">®</span> SPORT',
        description:
            'Shroom Tech<span class="oui-sup" aria-hidden="true">®</span> SPORT is designed to help the body with cellular energy.  Its adaptogenic compounds help promote exercise volume, assist aerobic performance, and support energy utilization.<span class="oui-sup">†</span>',
        img: "2024-STS-Free-Trial-WPage-1920x1080.jpg",
        imgAltText: "Man and woman lifting kettlebells",
        quote:
            "You won't know it worked until after your workout, when you'll think, 'D*mn that was easier than it usually is.'",
        author: "Svenotto Fishmo",
        productSlug: "shroomtech-sport",
        productId: 4448,
        trialSlug: "shroom-tech-sport-offer",
        trialProductId: TrialProductIds.ShroomTechSport,
    },
};
